// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const insight = "Insight__insight__DKQ08";
export const notTouchable = "Insight__notTouchable__HPSJy";
export const sponsoredLabel = "Insight__sponsoredLabel__BsZ7U font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";
export const noCard = "Insight__noCard__Ot5ie";
export const body = "Insight__body__c-F4O";
export const mediaPlaceholder = "Insight__mediaPlaceholder__+xDdA";
export const mediaImage = "Insight__mediaImage__VgLSe";
export const isPage = "Insight__isPage__BJSzg";
export const isHighlight = "Insight__isHighlight__6ATj3";
export const scrollableWrapper = "Insight__scrollableWrapper__00ojQ";
export const isModule = "Insight__isModule__3yQlM";
export const header = "Insight__header__-qRGi";
export const none = "Insight__none__Mmq8O";
export const green = "Insight__green__zPziw";
export const blue = "Insight__blue__skfOM";
export const orange = "Insight__orange__OHREP";
export const red = "Insight__red__RVAnK";
export const leftBadgeWrapper = "Insight__leftBadgeWrapper__oOK1S";
export const rightBadgeWrapper = "Insight__rightBadgeWrapper__KRtlH";
export const category = "Insight__category__bxJ8D";
export const notScrollable = "Insight__notScrollable__1r0p1";
export const content = "Insight__content__QfBHR";
export const title = "Insight__title__StRiA font-faces__serifMedium__n-4rV font-faces__serif__XseuP";
export const text = "Insight__text__9EVry Text__bodyText__20Sxx font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const hasNoTitle = "Insight__hasNoTitle__ef0lx";
export const footer = "Insight__footer__Wu7KF";